import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Space extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>Space</h2>
        <p>
        Finding a suitable space for your plants is the first step in preparing your grow. For indoor growing you can use a closet, a cabinet or a tent. Pre built tents are available online or you can build your own. If you're going the prebuilt route one of your best options is the <a target="_blank" href="https://www.amazon.com/gp/product/B01DXYMQ9M/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01DXYMQ9M&linkCode=as2&tag=blacksquare05-20&linkId=66d6d6302077ec74c858976147d6c56c">Vivosun Hydroponic Grow Tent</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B01DXYMQ9M" width="1" height="1" alt="" className="amazon__pixel" /> which comes in a variety of sizes to accomodate whatever space you're looking to fill. Whatever you choose, make sure your grow space meets the following criteria.
        </p>
        <ul>
          <li className="highlight">Light Proof. You must guarantee total darkness when your plants need it.</li>
          <li className="highlight">An appropriate light, with adjustable vertical height.</li> 
          <li className="highlight">Reflective walls (Mylar or Foil) to disperse the light.</li>
          <li className="highlight">Ventilation, both intake and exhaust to circulate fresh air.</li> 
        </ul>
        <h3>Selecting Pots</h3>
        <p>
        For indoor growing we recommend growing in 5 gallon pots, although you can go as big as 10 gallon pots if you have the space. <a target="_blank" href="https://www.amazon.com/gp/product/B013JM3JSA/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B013JM3JSA&linkCode=as2&tag=blacksquare05-20&linkId=e2d56ca71d5a2d829c394cdbe2fe8ec6">247Garden 5 Gallon Fabric Pots</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B013JM3JSA" width="1" height="1" alt="" className="amazon__pixel" /> are an excellent choice. Each pots footprint will be around 1 square foot although plants will expand as they grow so try and not overcrowd your space with plants. This will cause them to fight for light, and reduce yield at the bottom of plant. You’ll also need a reliable water basin for each plant. It’s also a good idea to put a tarp or water basin under your whole grow space as growing can get messy. 
        </p>
        <h3>Plant Height</h3>
        <p>
        Marijuana plants will grow upwards of 4 to 5 feet tall, although you can limit their height by switching them from the vegetative to flowering stage earlier in the grow. Most plants will double in size during the flowering process. Make sure you are accounting for all of this growth when you plan out your space. For example, if the maximum height in your grow space is six feet tall, make sure you are switching your plants to flowering at 2 to 3 fe
        </p>
        <div className="guide__shopping-list">
          <h3>Shopping List</h3>
          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B01DXYMQ9M&asins=B01DXYMQ9M&linkId=c7741c330d404ff1040cd254d1199f80&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B013JM3JSA&asins=B013JM3JSA&linkId=0e5c09779cdbe5f768df89ed79a60305&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>
        </div>
        <GuideButton slugTo="light" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_space.js